module.exports = __webpack_public_path__ + "img/low-fat-strawberry-shortcake.bdbeca45.jpg";